




























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Autocomplete extends Vue {
  loading = false;
  items: [] = [];
  searchInput = "";
  @Prop() value: unknown;
  @Prop() search?: (query: string) => Promise<[]>;
  @Prop() placeholder?: string;
  @Prop() label?: string;
  @Prop() multiple?: boolean;
  @Prop() disabled?: boolean;
  @Prop() itemText?: string;

  mounted() {
    this.$watch(() => this.searchInput, this.onSearch);
  }

  onValueChanged(newValue: unknown) {
    this.$emit("input", newValue);
  }

  clearCache() {
    const myAuto = this.$refs.autocomp as any;
    myAuto.cachedItems = [];
  }

  async onSearch(query: string) {
    this.loading = true;

    if (this.search) this.items = await this.search(query);

    this.loading = false;
  }
}
